import React from 'react';
import {Preloader} from 'MWC';
import DOMPurify from 'utils/sanitize';
import {canUseDOM} from '../../../helpers/canUseDOM';
import '../less/top.less';
import ppbPhoto from '../../../assets/img/owners/kandaurov.png';
import deputyPhoto from '../../../assets/img/owners/krasheninnikova.png';
import deputy2Photo from '../../../assets/img/owners/bakanova.png';
import deputy3Photo from '../../../assets/img/owners/juravlov.png';
import deputy4Photo from '../../../assets/img/owners/vasilenko.png';
import deputy6Photo from '../../../assets/img/owners/tribulkin.png';
import deputy7Photo from '../../../assets/img/owners/zaychenko.png';
import CustomDropdown from '../../../auxiliary-components/shared/CustomDropdownNew';
import FilesForDownloadNew from '../../../auxiliary-components/shared/FilesForDownloadNew';
import FilesForDownloadLocal from '../../../auxiliary-components/shared/FilesForDownloadLocal';
import TitleBlock from "../../../auxiliary-components/shared/TitleBlock/views/TitleBlock";
import {aboutTop2022link_1, aboutTop2022link_2, aboutTop2022link_3} from "../../../services/urls/urls";

export default function template() {


    return (
        <div className="module-about-top">
            <div className="top-management-wrapper">
                <div className='container'>
                    <TitleBlock title='ABOUT_TOP_TAB_RULERS' tag='h2' />
                    <div className="top-tree">
                        <div className="person-item">
                            <img src={ppbPhoto} alt="" />
                            <h2 className="main-text">{this.l10n('ABOUT_OWNERS_HEAD_NAME')}</h2>
                            <p className="second-text">{this.l10n('ABOUT_OWNERS_HEAD_POSITION')}</p>
                        </div>
                        <div className="person-item">
                            <img src={deputyPhoto} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_NAME')}
                            </h2>
                            <p className="second-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_POSITION')}
                            </p>
                        </div>
                        <div className="person-item">
                            <img src={deputy2Photo} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_2_NAME')}
                            </h2>
                            <p className="second-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_2_POSITION')}
                            </p>
                        </div>
                        <div className="person-item">
                            <img src={deputy4Photo} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_4_NAME')}
                            </h2>
                            <p className="second-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_2_POSITION')}
                            </p>
                        </div>
                        <div className="person-item">
                            <img src={deputy6Photo} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_6_NAME')}
                            </h2>
                            <p
                                className="second-text"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_2_POSITION')),
                                }}
                            />
                        </div>
                        <div className="person-item">
                            <img src={deputy7Photo} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_7_NAME')}
                            </h2>
                            <p
                                className="second-text"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_2_POSITION')),
                                }}
                            />
                        </div>
                        <div className="person-item">
                            <img src={deputy3Photo} alt="" />
                            <h2 className="main-text">
                                {this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_3_NAME')}
                            </h2>
                            <p
                                className="second-text"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(this.l10n('ABOUT_OWNERS_DEPUTY_HEAD_3_POSITION')),
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="middle-wrapper">
                    <TitleBlock title='ABOUT_TOP_TAB_SUPERVISORS' tag='h2' />
                    <div className="supervisory-board">
                            <div className="supervisory-board-item">
                                <h3 className="main-title">
                                    {this.l10n('ABOUT_SUPERVISORS_1_NAME')}
                                </h3>
                                <p className="profession-text">
                                    {this.l10n('ABOUT_SUPERVISORS_1_POSITION')}
                                </p>
                            </div>
                            <div className="supervisory-board-item">
                                <h3 className="main-title">
                                    {this.l10n('ABOUT_SUPERVISORS_2_NAME')}
                                </h3>
                                <p className="profession-text">
                                    {this.l10n('ABOUT_SUPERVISORS_2_POSITION')}
                                </p>
                            </div>
                            <div className="supervisory-board-item">
                                <h3 className="main-title">
                                    {this.l10n('ABOUT_SUPERVISORS_3_NAME')}
                                </h3>
                                <p className="profession-text">
                                    {this.l10n('ABOUT_SUPERVISORS_3_POSITION')}
                                </p>
                            </div>
                            <div className="supervisory-board-item">
                                <h3 className="main-title">
                                    {this.l10n('ABOUT_SUPERVISORS_4_NAME')}
                                </h3>
                                <p className="profession-text">
                                    {this.l10n('ABOUT_SUPERVISORS_4_POSITION')}
                                </p>
                            </div>
                            <div className="supervisory-board-item">
                                <h3 className="main-title">
                                    {this.l10n('ABOUT_SUPERVISORS_5_NAME')}
                                </h3>
                                <p className="profession-text">
                                    {this.l10n('ABOUT_SUPERVISORS_5_POSITION')}
                                </p>
                            </div>
                    </div>
                </div>
                <div className="info-wrapper">
                    <TitleBlock title='ABOUT_OWNERS_CUT_SUPERVISORY_MEETINGS' tag='h2' />
                    <CustomDropdown chevron_icon title={this.l10n("ABOUT_OWNERS_CUT_TITLE_06")} titleTag={"h3"}>
                        {this.state.widgets_4_loading ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew lang={this.props.lang} page={'about'} widget={this.widgetsHelper.getWidgetFrom.call(this, 'widgets_4', 'files_to_download')}/>}
                    </CustomDropdown>
                    <CustomDropdown chevron_icon title={this.l10n("ABOUT_OWNERS_CUT_TITLE_05")} titleTag={"h3"}>
                        {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew lang={this.props.lang} page={'about'} widget={this.widgetsHelper.getWidget_3.call(this, "files_to_download")}/>}
                    </CustomDropdown>
                    <CustomDropdown chevron_icon title={this.l10n("ABOUT_OWNERS_CUT_TITLE_04")} titleTag={"h3"}>
                        {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew lang={this.props.lang} page={'about'} widget={this.widgetsHelper.getWidget_2.call(this, "files_to_download")}/>}
                    </CustomDropdown>
                    <CustomDropdown chevron_icon title={this.l10n("ABOUT_OWNERS_CUT_TITLE_03")} titleTag={"h3"}>
                        {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew page={'about'} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>}
                    </CustomDropdown>
                    <CustomDropdown chevron_icon title={this.l10n("ABOUT_OWNERS_CUT_TITLE_02")} titleTag={"h3"}>
                        <FilesForDownloadLocal
                            items={[
                                {
                                    text: "ABOUT_OWNERS_DOC_SUPERVISORY_MEETINGS_3",
                                    link: aboutTop2022link_1
                                },
                                {
                                    text: "ABOUT_OWNERS_DOC_SUPERVISORY_MEETINGS_2",
                                    link: aboutTop2022link_2
                                },
                                {
                                    text: "ABOUT_OWNERS_DOC_SUPERVISORY_MEETINGS_1",
                                    link: aboutTop2022link_3
                                }
                            ]}
                        />
                    </CustomDropdown>
                </div>
            </div>
        </div>
    );
}
